import React from 'react';
import { Typography, Link } from '@mui/material';


const Copyright = (props: any) => {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            Copyright ©
            <Link component="a" color="inherit" href={process.env.REACT_APP_ORIGIN}>
                {process.env.REACT_APP_FULL_NAME} System
            </Link>{' '}
            2021-{new Date().getFullYear()}.
        </Typography>
    );
}

export default Copyright;
